import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import { staticBounceVariants } from "shared/components/animations";
const DidYouKnow = ({ joke }) => {
  return (
    <motion.div
      variants={staticBounceVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="did-you-know"
    >
      <h2>Did You Know?</h2>
      <p> {joke}</p>
    </motion.div>
  );
};

export default DidYouKnow;
